import { Card, CardContent, Typography, Box } from "@mui/material";

export default function BenefitCard({ icon, title, description }) {
  return (
    <Card
      sx={{
        height: "100%",
        bgcolor: "background.black_shade_secondary",
        borderRadius: "10px",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-5px)",
        },
      }}
    >
      <CardContent>
        <Box sx={{ color: "primary.main", mb: 2 }}>{icon}</Box>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}
